export * from './readOrganizationInfoProc';
export * from './updateSharingProc';
export * from './bulkCreateSharingProc';
export * from './readSharingProc';
export * from './getCustomerInfoProc';
export * from './deleteMemberProc';
export * from './deletePreferenceProc';
export * from './bulkCreateOrganizationInfoProc';
export * from './flushSharingForTesting';
export * from './createOrganizationInfoProc';
export * from './getMemberListProc';
export * from './flushPreferenceForTesting';
export * from './createPreferenceProc';
export * from './getPreferenceProc';
export * from './getOrganizationListProc';
export * from './deleteSharingProc';
export * from './createSharingProc';
export * from './bulkUpdateSharingProc';
export * from './updateMemberProc';
export * from './flushOrganizationInfoForTesting';
export * from './deleteOrganizationInfoProc';
export * from './createMemberProc';
export * from './updatePreferenceProc';
export * from './updateOrganizationInfoProc';
export * from './bulkUpdateOrganizationInfoProc';

let logoutFunc: () => void;
/**
 *
 * @param func
 */
const setLogoutFunc = (func: any) => {
  logoutFunc = func;
};

let awsResources: any;
let salt: string;
/**
 *
 * @param res
 * @param saltStr
 */
const setAwsResources = (res: any, saltStr: string) => {
  awsResources = res;
  salt = saltStr.charAt(0).toUpperCase() + saltStr.slice(1);
};

export { logoutFunc, awsResources, salt };
export { setLogoutFunc, setAwsResources };
